
<div id="print-box" hidden>
  <div id="chart" style="width:70%;height:400px">
    <xml-report-print [config]="config()"
    (passChartData)="receiveChartData($event)"></xml-report-print>
  </div>

  @if (chartData) {
    <div id="table">
      @if (chartData.detailedTable) {
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              @for (column of chartData.detailedTable.columns; track column) {
                <th>{{column}}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of chartData.detailedTable.rows; track row; let i = $index) {
              <tr>
                @for (rowItem of row; track rowItem; let j = $index) {
                  <td
                    class="text-{{chartData.detailedTable.alignments[i][j].toLowerCase()}} {{chartData.detailedTable.colors[i][j]}}">
                    {{rowItem}}
                  </td>
                }
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              @for (column of chartData.detailedTable.columns; track column) {
                <th>&ensp;</th>
              }
            </tr>
          </tfoot>
        </table>
      }
    </div>
  }

  @if (chartData) {
    <div id="description">
      <table class="table table-sm content-table">
        <thead><tr><th></th></tr></thead>
        <tbody><tr><td><div [innerHTML]="chartData.descriptionHtml"></div></td></tr></tbody>
        <tfoot><tr><th></th></tr></tfoot>
      </table>
    </div>
  }
</div>
